module.exports = __webpack_public_path__ + "img/011.6dc29950.jpg";